export default "__VITE_ASSET__e759dccb__"